/* Tartan Today cart (2026-10-01) - interactions for snippets/tt-cart.liquid
   (cart page + Halo cart drawer). Uses Shopify's Cart AJAX API; the drawer is
   re-rendered through Halo's own window.sharedFunctions.updateSidebarCart, the
   cart page through the Section Rendering API. */
(function () {
  if (window.ttCartInit) return;
  window.ttCartInit = true;

  var openDetails = {}; // remembers open <details> (note / code) across re-renders

  function post(url, data) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) { var e = new Error(j.description || j.message || 'Something went wrong'); e.data = j; throw e; }
        return j;
      });
    });
  }
  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  function rememberDetails(root) {
    root.querySelectorAll('details[data-tt-details]').forEach(function (d) { openDetails[d.dataset.ttDetails] = d.open; });
  }
  function restoreDetails(root) {
    if (!root) return;
    root.querySelectorAll('details[data-tt-details]').forEach(function (d) {
      if (openDetails[d.dataset.ttDetails] === true) d.open = true;
    });
  }
  function updateCounts(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (e) { e.textContent = cart.item_count; });
  }

  function refreshPage() {
    var page = document.querySelector('[data-tt-cart-root][data-context="page"]');
    if (!page) return Promise.resolve();
    rememberDetails(page);
    return fetch('/cart?section_id=' + encodeURIComponent(page.dataset.sectionId))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-tt-cart-root][data-context="page"]');
        if (fresh) { page.replaceWith(fresh); restoreDetails(fresh); placeMobileBar(); checkExpress(); }
      });
  }
  function refreshDrawer(cart) {
    var drawer = document.querySelector('[data-tt-cart-root][data-context="drawer"]');
    if (!drawer) return;
    rememberDetails(drawer);
    if (window.sharedFunctions && typeof window.sharedFunctions.updateSidebarCart === 'function') {
      window.sharedFunctions.updateSidebarCart(cart); // Halo re-fetches /cart?view=ajax_side_cart, then fires "cart-update"
    } else {
      fetch('/cart?view=ajax_side_cart').then(function (r) { return r.text(); }).then(function (html) {
        var wrap = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
        if (wrap) { wrap.innerHTML = html; restoreDetails(wrap); }
      });
    }
  }
  document.addEventListener('cart-update', function () {
    restoreDetails(document.querySelector('[data-tt-cart-root][data-context="drawer"]'));
  });

  function refreshAll(cart) {
    var p = cart ? Promise.resolve(cart) : getCart();
    return p.then(function (c) {
      updateCounts(c);
      refreshDrawer(c);
      return refreshPage().then(function () { return c; });
    });
  }

  function busy(root, on) { if (root) root.classList.toggle('is-busy', !!on); }
  function showErr(root, msg) {
    var el = root && root.querySelector('[data-tt-err]');
    if (!el) return;
    el.textContent = msg; el.hidden = false;
    setTimeout(function () { el.hidden = true; }, 6000);
  }
  function showMsg(scope, msg, ok) {
    var el = scope && scope.querySelector('[data-tt-msg]');
    if (!el) return;
    el.textContent = msg; el.hidden = false;
    el.classList.toggle('is-ok', !!ok);
  }

  // ---- discount codes (Cart AJAX API: POST /cart/update.js {discount}) ----
  function applyCode(root, code, scope, btn) {
    code = (code || '').trim().toUpperCase();
    if (!code) return;
    busy(root, true); if (btn) btn.disabled = true;
    getCart().then(function (cur) {
      if (!('discount_codes' in cur)) { window.location.href = '/checkout?discount=' + encodeURIComponent(code); return; }
      var keep = (cur.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
      if (keep.some(function (c) { return c.toUpperCase() === code; })) { showMsg(scope, code + ' is already applied.', true); return; }
      return post('/cart/update.js', { discount: keep.concat([code]).join(',') }).then(function (res) {
        var hit = (res.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === code; })[0];
        if (hit && hit.applicable) return refreshAll(res);
        // not applicable: take it back off so checkout stays clean, and say so
        return post('/cart/update.js', { discount: keep.join(',') }).then(function () {
          showMsg(scope, '“' + code + '” can’t be applied to this cart. Check the code and any minimum order amount.', false);
        });
      });
    }).catch(function (e) { showMsg(scope, e.message, false); })
      .then(function () { busy(root, false); if (btn) btn.disabled = false; });
  }
  function removeCode(root, code) {
    busy(root, true);
    getCart().then(function (cur) {
      var keep = (cur.discount_codes || []).filter(function (d) { return d.applicable && d.code.toUpperCase() !== code.toUpperCase(); }).map(function (d) { return d.code; });
      return post('/cart/update.js', { discount: keep.join(',') });
    }).then(function (res) { return refreshAll(res); })
      .catch(function (e) { showErr(root, e.message); })
      .then(function () { busy(root, false); });
  }

  // ---- clicks ----
  document.addEventListener('click', function (ev) {
    var t = ev.target.closest('[data-tt-qty],[data-tt-remove],[data-tt-add],[data-tt-apply],[data-tt-code-apply],[data-tt-code-remove]');
    if (!t) return;
    var root = t.closest('[data-tt-cart-root]');
    if (!root) return;
    ev.preventDefault();
    var line = t.closest('[data-tt-line]');

    if (t.matches('[data-tt-qty],[data-tt-remove]') && line) {
      var qty = t.matches('[data-tt-remove]') ? 0 : Math.max(0, parseInt(line.dataset.qty, 10) + parseInt(t.dataset.ttQty, 10));
      busy(root, true);
      post('/cart/change.js', { id: line.dataset.key, quantity: qty })
        .then(function (cart) { return refreshAll(cart); })
        .catch(function (e) { showErr(root, e.message); })
        .then(function () { busy(root, false); });
    } else if (t.matches('[data-tt-add]')) {
      t.disabled = true; t.textContent = 'Adding…';
      busy(root, true);
      post('/cart/add.js', { items: [{ id: parseInt(t.dataset.ttAdd, 10), quantity: 1 }] })
        .then(function () { return refreshAll(); })
        .catch(function (e) { t.disabled = false; t.textContent = '+ Add'; showErr(root, e.message); })
        .then(function () { busy(root, false); });
    } else if (t.matches('[data-tt-apply]')) {
      applyCode(root, t.dataset.ttApply, t.closest('[data-tt-offer]'), t);
    } else if (t.matches('[data-tt-code-apply]')) {
      var box = t.closest('details');
      applyCode(root, box.querySelector('[data-tt-code-input]').value, box, t);
    } else if (t.matches('[data-tt-code-remove]')) {
      removeCode(root, t.dataset.ttCodeRemove);
    }
  });
  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Enter' && ev.target.matches && ev.target.matches('[data-tt-code-input]')) {
      ev.preventDefault();
      var box = ev.target.closest('details');
      applyCode(ev.target.closest('[data-tt-cart-root]'), ev.target.value, box, box.querySelector('[data-tt-code-apply]'));
    }
  });
  document.addEventListener('toggle', function (ev) {
    if (ev.target.matches && ev.target.matches('details[data-tt-details]')) openDetails[ev.target.dataset.ttDetails] = ev.target.open;
  }, true);

  // ---- gift note = Shopify cart note (auto-saved) ----
  var noteTimer;
  function saveNote(ta) {
    var status = ta.parentNode.querySelector('[data-tt-note-status]');
    if (status) status.textContent = 'Saving…';
    post('/cart/update.js', { note: ta.value })
      .then(function () {
        if (status) status.textContent = 'Saved ✓';
        document.querySelectorAll('[data-tt-note]').forEach(function (o) { if (o !== ta) o.value = ta.value; });
      })
      .catch(function () { if (status) status.textContent = 'Could not save — please try again'; });
  }
  document.addEventListener('input', function (ev) {
    if (!ev.target.matches || !ev.target.matches('[data-tt-note]')) return;
    clearTimeout(noteTimer);
    var ta = ev.target;
    noteTimer = setTimeout(function () { saveNote(ta); }, 700);
  });
  document.addEventListener('change', function (ev) {
    if (ev.target.matches && ev.target.matches('[data-tt-note]')) { clearTimeout(noteTimer); saveNote(ev.target); }
  });

  // ---- express buttons: Shopify only loads their script on product/cart pages;
  // collapse the slot wherever they did not render (e.g. drawer on the homepage) ----
  function checkExpress() {
    setTimeout(function () {
      document.querySelectorAll('.tt-express').forEach(function (x) {
        x.classList.toggle('is-empty', x.getBoundingClientRect().height < 8);
      });
    }, 2500);
  }
  document.addEventListener('cart-update', checkExpress);
  window.addEventListener('load', checkExpress);

  // ---- mobile sticky bar sits just above Halo's bottom toolbar ----
  function placeMobileBar() {
    var bar = document.querySelector('[data-tt-mbar]');
    if (!bar) return;
    var tb = document.querySelector('.halo-sticky-toolbar-mobile');
    var h = 0;
    if (tb) { var r = tb.getBoundingClientRect(); if (r.height > 0 && getComputedStyle(tb).display !== 'none') h = Math.round(r.height); }
    bar.style.setProperty('--tt-toolbar-h', h + 'px');
  }
  window.addEventListener('resize', placeMobileBar);
  window.addEventListener('load', placeMobileBar);
  document.addEventListener('DOMContentLoaded', placeMobileBar);
  placeMobileBar();
})();
